import {
  buildInitialRoomsAndPaxInfo,
  paxSlotsMatchRoomComposition,
} from "./buildInitialRoomsAndPaxInfo";

/**
 * Decide whether roomsAndPaxInfo must be rebuilt from the current search occupancy.
 * Does not keep previous-search passenger slots when occupancy changed —
 * named form data from search #1 must not leak into search #2.
 *
 * @param {{
 *   roomsComposition: Array|null|undefined,
 *   roomsAndPaxInfo: Array|null|undefined,
 *   ourSavedLDSOrder?: object|null,
 *   selectedResultDealType?: string,
 * }} input
 */
export function resolvePassengerSlotsForSearchOccupancy({
  roomsComposition,
  roomsAndPaxInfo,
  ourSavedLDSOrder = null,
  selectedResultDealType = "",
}) {
  const hasHydratedSavedOrderRooms =
    !!ourSavedLDSOrder?.id &&
    Array.isArray(roomsAndPaxInfo) &&
    roomsAndPaxInfo.length > 0;
  if (hasHydratedSavedOrderRooms) {
    return { action: "keep", reason: "saved_order" };
  }

  const savedDealType =
    ourSavedLDSOrder?.deal_type ||
    ourSavedLDSOrder?.dealType ||
    selectedResultDealType ||
    "";
  if (savedDealType === "OrganizedTour" && ourSavedLDSOrder?.id) {
    return { action: "keep", reason: "organized_tour_saved" };
  }

  const rooms = Array.isArray(roomsComposition) ? roomsComposition : [];
  if (rooms.length === 0) {
    return { action: "wait", reason: "composition_not_ready" };
  }

  const searchSlotCount = rooms.length;
  const searchSlots = Array.isArray(roomsAndPaxInfo)
    ? roomsAndPaxInfo.slice(0, searchSlotCount)
    : [];

  if (paxSlotsMatchRoomComposition(searchSlots, { rooms })) {
    return { action: "keep", reason: "occupancy_matches" };
  }

  return {
    action: "rebuild",
    reason: "occupancy_mismatch",
    roomsAndPaxInfo: buildInitialRoomsAndPaxInfo({ rooms }),
  };
}

export function formatRoomsAndPaxCompositionLabel(roomsAndPaxInfo) {
  if (!Array.isArray(roomsAndPaxInfo) || roomsAndPaxInfo.length === 0) return "";
  let totalAdults = 0;
  let totalKids = 0;
  let totalInfants = 0;
  roomsAndPaxInfo.forEach((roomInfo) => {
    totalAdults += roomInfo?.adults?.length || 0;
    totalKids += roomInfo?.kids?.length || 0;
    totalInfants += roomInfo?.infants?.length || 0;
  });
  const roomsCount = roomsAndPaxInfo.length;
  const parts = [];
  if (roomsCount > 0) {
    parts.push(`${roomsCount} ${roomsCount === 1 ? "חדר" : "חדרים"}`);
  }
  if (totalAdults > 0) {
    parts.push(`${totalAdults} ${totalAdults === 1 ? "מבוגר" : "מבוגרים"}`);
  }
  if (totalKids > 0) {
    parts.push(`${totalKids} ${totalKids === 1 ? "ילד" : "ילדים"}`);
  }
  if (totalInfants > 0) {
    parts.push(`${totalInfants} ${totalInfants === 1 ? "תינוק" : "תינוקות"}`);
  }
  return parts.join(", ");
}
